export default __webpack_public_path__ + "static/media/linkin_logo.8fece1c6.png";